import { ViewportScroller } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TokenStorageService } from '../../services/storage/token-storage.service';
import { AppConfigService } from '../../services/config/app-config.service';
import { KeycloakService } from 'keycloak-angular';
import { WindowRefService } from '../../services/window/window-ref.service';
import { RegistrationModalService } from '../../services/registration-modal.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  userType = '';
  tradeDomain: string | undefined;
  priceDomain: string | undefined;
  user: any;
  dynamicWord: string = 'Neobroker';
  isLoggedIn: boolean = false;

  constructor(
    private scroller: ViewportScroller,
    private appConfig: AppConfigService,
    private tokenStorageService: TokenStorageService,
    private keycloakService: KeycloakService,
    private windowRef: WindowRefService,
    private registrationModalService: RegistrationModalService

  ) {
    const hostname = this.windowRef.nativeWindow.location.hostname;

    this.tradeDomain = appConfig.getCommonConfig?.tradeDomain;
    this.priceDomain = appConfig.getCommonConfig?.priceDomain;
    this.userType =
      hostname === this.priceDomain
        ? 'FEED'
        : hostname === this.tradeDomain
          ? 'OMS'
          : '';
  }

  ngOnInit(): void {
    this.user = this.tokenStorageService.getUser();
    //  this.isLoggedIn = !!this.tokenStorageService.getToken();
    this.isLoggedIn = this.keycloakService.isLoggedIn();
    this.cycleWords();
  }

  goToAPIRef() {
    this.scroller.scrollToAnchor('api');
  }

  openRegistration(event: Event) {
    event.preventDefault();
    this.registrationModalService.open();
  }

  cycleWords(): void {
    const words = [
      'Wealthtechs',
      'Neobanks',
      'Trading Apps',
      'Digital Wallets',
    ];
    let index = 0;

    setInterval(() => {
      this.dynamicWord = words[index];
      index = (index + 1) % words.length; // Loop through words
    }, 5000); // Change word every 5 seconds
  }
}
